var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"head",staticClass:"tabs-head"},[_vm._t("default"),_c('div',{ref:"line",staticClass:"line"}),_c('div',{staticClass:"actions-wrapper"},[_vm._t("actions")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }